
import { Record, Union } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { class_type, list_type, record_type, option_type, int32_type, float64_type, string_type, union_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { singleton as singleton_1, tail, iterate as iterate_1, ofArray, last as last_1, head, empty as empty_1, choose, toArray, sort, max, min, isEmpty, append, length, averageBy, map as map_9 } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { List_groupBy } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq2.js";
import { equals, comparePrimitives, int32ToString, arrayHash, equalArrays } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { join, interpolate, toText, concat } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { reactApi, reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { iterate, empty, singleton, append as append_1, delay, toList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { toArray as toArray_1, bind, defaultArg, filter, map as map_10, ofNullable } from "../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { rangeDouble } from "../fable_modules/fable-library-js.5.0.0-rc.2/Range.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { createDisposable, useEffectDisposableOnce } from "../fable_modules/Feliz.2.9.0/Internal.fs.js";
import { Marker, FullscreenControl, NavigationControl, Map as Map$ } from "maplibre-gl";
import { Operators_IsNull } from "../fable_modules/fable-library-js.5.0.0-rc.2/FSharp.Core.js";
import { useTranslation } from "react-i18next";
import { useMapConfiguration } from "../Requests/Telematics.js";
import { useEffectWithDeps } from "../fable_modules/Feliz.2.9.0/ReactInterop.js";
import { load } from "../Bindings/GoogleMaps.js";
import { Skeleton } from "../Components/Skeleton.js";

export class MarkerStatus extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Online", "Offline", "Stale"];
    }
}

export function MarkerStatus_$reflection() {
    return union_type("Widgets.TrackerMap.MarkerStatus", [], MarkerStatus, () => [[], [], []]);
}

export class MarkerKind extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Tool", "Set", "Unassigned"];
    }
}

export function MarkerKind_$reflection() {
    return union_type("Widgets.TrackerMap.MarkerKind", [], MarkerKind, () => [[], [], []]);
}

export class TrackerMarker extends Record {
    constructor(Id, Label, Latitude, Longitude, Status, Kind, AccuracyMeters, Heading) {
        super();
        this.Id = Id;
        this.Label = Label;
        this.Latitude = Latitude;
        this.Longitude = Longitude;
        this.Status = Status;
        this.Kind = Kind;
        this.AccuracyMeters = AccuracyMeters;
        this.Heading = Heading;
    }
}

export function TrackerMarker_$reflection() {
    return record_type("Widgets.TrackerMap.TrackerMarker", [], TrackerMarker, () => [["Id", string_type], ["Label", string_type], ["Latitude", float64_type], ["Longitude", float64_type], ["Status", MarkerStatus_$reflection()], ["Kind", MarkerKind_$reflection()], ["AccuracyMeters", option_type(int32_type)], ["Heading", option_type(int32_type)]]);
}

export class LocationMarker extends Record {
    constructor(Id, Label, Latitude, Longitude) {
        super();
        this.Id = Id;
        this.Label = Label;
        this.Latitude = Latitude;
        this.Longitude = Longitude;
    }
}

export function LocationMarker_$reflection() {
    return record_type("Widgets.TrackerMap.LocationMarker", [], LocationMarker, () => [["Id", string_type], ["Label", string_type], ["Latitude", float64_type], ["Longitude", float64_type]]);
}

export class Cluster extends Record {
    constructor(Latitude, Longitude, Members) {
        super();
        this.Latitude = Latitude;
        this.Longitude = Longitude;
        this.Members = Members;
    }
}

export function Cluster_$reflection() {
    return record_type("Widgets.TrackerMap.Cluster", [], Cluster, () => [["Latitude", float64_type], ["Longitude", float64_type], ["Members", list_type(TrackerMarker_$reflection())]]);
}

export const clusterThreshold = 50;

const clusterCellPixels = 60;

export function clusterMarkers(zoom, markers) {
    const cell = (clusterCellPixels * 360) / (256 * Math.pow(2, zoom));
    return map_9((tupledArg) => {
        const members = tupledArg[1];
        return new Cluster(averageBy((marker_1) => marker_1.Latitude, members, {
            GetZero: () => 0,
            Add: (x_2, y_1) => (x_2 + y_1),
            DivideByInt: (x_1, i) => (x_1 / i),
        }), averageBy((marker_2) => marker_2.Longitude, members, {
            GetZero: () => 0,
            Add: (x_4, y_2) => (x_4 + y_2),
            DivideByInt: (x_3, i_1) => (x_3 / i_1),
        }), members);
    }, List_groupBy((marker) => [Math.floor(marker.Longitude / cell), Math.floor(marker.Latitude / cell)], markers, {
        Equals: equalArrays,
        GetHashCode: (x) => (arrayHash(x) | 0),
    }));
}

export class TrackPoint extends Record {
    constructor(Latitude, Longitude, RecordedAt) {
        super();
        this.Latitude = Latitude;
        this.Longitude = Longitude;
        this.RecordedAt = RecordedAt;
    }
}

export function TrackPoint_$reflection() {
    return record_type("Widgets.TrackerMap.TrackPoint", [], TrackPoint, () => [["Latitude", float64_type], ["Longitude", float64_type], ["RecordedAt", class_type("System.DateTime")]]);
}

const accuracyCircleFrom = 30;

const selectedColor = "#1d4ed8";

const trackStartColor = "#16a34a";

const trackEndColor = "#dc2626";

const locationColor = "#1c1c42";

const maxFitZoom = 16;

function statusColor(status) {
    switch (status.tag) {
        case 1:
            return "#6b7280";
        case 2:
            return "#f59e0b";
        default:
            return "#16a34a";
    }
}

function markerElement(marker, isSelected) {
    const element = document.createElement("div");
    element.className = "tracker-marker";
    element.setAttribute("data-test-id", concat("tracker-marker-", ...marker.Id));
    element.title = marker.Label;
    element.setAttribute("style", "width: 18px; height: 18px; cursor: pointer;");
    const border = isSelected ? concat("3px solid ", ...selectedColor) : ((marker.Kind.tag === 2) ? "2px dashed #ffffff" : "2px solid #ffffff");
    let radius;
    const matchValue_2 = marker.Kind;
    switch (matchValue_2.tag) {
        case 0:
        case 2: {
            radius = "50%";
            break;
        }
        default:
            radius = "4px";
    }
    const dot = document.createElement("div");
    dot.setAttribute("style", `position: relative; width: 18px; height: 18px; box-sizing: border-box; border-radius: ${radius}; background: ${statusColor(marker.Status)}; border: ${border}; box-shadow: 0 1px 4px rgba(0,0,0,0.4);`);
    const matchValue_3 = marker.Heading;
    if (matchValue_3 == null) {
    }
    else {
        const heading = matchValue_3 | 0;
        const arrow = document.createElement("div");
        arrow.setAttribute("style", `position: absolute; left: 50%; top: -14px; width: 0; height: 0; border-left: 5px solid transparent; border-right: 5px solid transparent; border-bottom: 10px solid ${statusColor(marker.Status)}; transform-origin: 50% 23px; transform: translateX(-50%) rotate(${heading}deg);`);
        dot.appendChild(arrow);
    }
    element.appendChild(dot);
    return element;
}

function locationMarkerElement(marker, isSelected) {
    const element = document.createElement("div");
    element.className = "location-marker";
    element.setAttribute("data-test-id", concat("location-marker-", ...marker.Id));
    element.title = marker.Label;
    element.setAttribute("style", "width: 28px; height: 40px; cursor: pointer; filter: drop-shadow(0 1px 3px rgba(0,0,0,0.4));");
    const patternInput = isSelected ? [selectedColor, "3"] : ["#ffffff", "2"];
    element.innerHTML = (((((("<svg width=\"28\" height=\"40\" viewBox=\"0 0 28 40\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M14 1.5C7.1 1.5 1.5 7.1 1.5 14c0 9.4 12.5 24.5 12.5 24.5S26.5 23.4 26.5 14C26.5 7.1 20.9 1.5 14 1.5z\" fill=\"" + locationColor) + "\" stroke=\"") + patternInput[0]) + "\" stroke-width=\"") + patternInput[1]) + "\"/><circle cx=\"14\" cy=\"14\" r=\"5\" fill=\"#ffffff\"/></svg>");
    return element;
}

function clusterElement(cluster) {
    const element = document.createElement("div");
    element.className = "tracker-cluster";
    element.setAttribute("data-test-id", toText(interpolate("tracker-cluster-%.4f%P()-%.4f%P()", [cluster.Latitude, cluster.Longitude])));
    element.innerText = int32ToString(length(cluster.Members));
    element.setAttribute("style", concat("min-width: 32px; height: 32px; padding: 0 6px; border-radius: 16px; background: ", selectedColor, ..."; color: #ffffff; font-size: 13px; font-weight: 600; display: flex; align-items: center; justify-content: center; border: 2px solid #ffffff; box-shadow: 0 1px 4px rgba(0,0,0,0.4); cursor: pointer;"));
    return element;
}

function clickable(content, onClick) {
    content.onclick = ((_arg) => {
        onClick();
    });
    return content;
}

function bounds(markers, locations, track) {
    const coordinates = append(map_9((marker) => [marker.Latitude, marker.Longitude], markers), append(map_9((marker_1) => [marker_1.Latitude, marker_1.Longitude], locations), map_9((point) => [point.Latitude, point.Longitude], track)));
    if (isEmpty(coordinates)) {
        return undefined;
    }
    else {
        const coordinates_1 = coordinates;
        const latitudes = map_9((tuple) => tuple[0], coordinates_1);
        const longitudes = map_9((tuple_1) => tuple_1[1], coordinates_1);
        return [[min(latitudes, {
            Compare: (x, y) => (comparePrimitives(x, y) | 0),
        }), min(longitudes, {
            Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
        })], [max(latitudes, {
            Compare: (x_2, y_2) => (comparePrimitives(x_2, y_2) | 0),
        }), max(longitudes, {
            Compare: (x_3, y_3) => (comparePrimitives(x_3, y_3) | 0),
        })]];
    }
}

function fitKey(markers, locations, track) {
    return (((join(",", sort(map_9((marker) => marker.Id, markers), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    })) + "|") + join(",", sort(map_9((marker_1) => marker_1.Id, locations), {
        Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
    }))) + "|") + int32ToString(length(track));
}

function mapContainer(height, isHidden, container) {
    return reactElement("div", {
        "data-test-id": "tracker-map",
        style: {
            height: height,
            width: 100 + "%",
        },
        className: join(" ", toList(delay(() => append_1(singleton("rounded"), delay(() => append_1(singleton("overflow-hidden"), delay(() => (isHidden ? singleton("hidden") : empty())))))))),
        ref: (element) => {
            container.current = ofNullable(element);
        },
    });
}

const MapLibre_tileUrl = "https://tile.openstreetmap.org/{z}/{x}/{y}.png";

const MapLibre_attribution = "© <a href=\"https://www.openstreetmap.org/copyright\">OpenStreetMap</a> contributors";

const MapLibre_mapStyle = {
    version: 8,
    sources: {
        osm: {
            type: "raster",
            tiles: [MapLibre_tileUrl],
            tileSize: 256,
            attribution: MapLibre_attribution,
        },
    },
    layers: [{
        id: "osm",
        type: "raster",
        source: "osm",
    }],
};

function MapLibre_lngLat(longitude, latitude) {
    return [longitude, latitude];
}

function MapLibre_feature(geometry, properties) {
    return {
        type: "Feature",
        geometry: geometry,
        properties: properties,
    };
}

function MapLibre_featureCollection(features) {
    return {
        type: "FeatureCollection",
        features: toArray(features),
    };
}

function MapLibre_circlePolygon(latitude, longitude, radiusMeters) {
    const metersPerDegreeLongitude = 111320 * Math.cos((latitude * 3.141592653589793) / 180);
    return {
        type: "Polygon",
        coordinates: [toArray(map_9((step) => {
            const angle = ((step * 10) * 3.141592653589793) / 180;
            return MapLibre_lngLat(longitude + ((radiusMeters * Math.cos(angle)) / metersPerDegreeLongitude), latitude + ((radiusMeters * Math.sin(angle)) / 111320));
        }, toList(rangeDouble(0, 1, 36))))],
    };
}

function MapLibre_accuracyFeatures(markers) {
    return MapLibre_featureCollection(choose((marker) => map_10((meters_1) => MapLibre_feature(MapLibre_circlePolygon(marker.Latitude, marker.Longitude, meters_1), {
        id: marker.Id,
    }), filter((meters) => (meters >= accuracyCircleFrom), marker.AccuracyMeters)), markers));
}

function MapLibre_trackFeatures(track) {
    if (isEmpty(track)) {
        return MapLibre_featureCollection(empty_1());
    }
    else {
        const points = track;
        const coordinates = toArray(map_9((point) => MapLibre_lngLat(point.Longitude, point.Latitude), points));
        const first = head(points);
        const last = last_1(points);
        return MapLibre_featureCollection(ofArray([MapLibre_feature({
            type: "LineString",
            coordinates: coordinates,
        }, {
            kind: "line",
        }), MapLibre_feature({
            type: "Point",
            coordinates: MapLibre_lngLat(first.Longitude, first.Latitude),
        }, {
            kind: "start",
        }), MapLibre_feature({
            type: "Point",
            coordinates: MapLibre_lngLat(last.Longitude, last.Latitude),
        }, {
            kind: "end",
        })]));
    }
}

function MapLibre_addLayers(map) {
    map.addSource("accuracy", {
        type: "geojson",
        data: MapLibre_featureCollection(empty_1()),
    });
    map.addSource("track", {
        type: "geojson",
        data: MapLibre_featureCollection(empty_1()),
    });
    map.addLayer({
        id: "accuracy-fill",
        type: "fill",
        source: "accuracy",
        paint: {
            "fill-color": selectedColor,
            "fill-opacity": 0.12,
        },
    });
    map.addLayer({
        id: "accuracy-outline",
        type: "line",
        source: "accuracy",
        paint: {
            "line-color": selectedColor,
            "line-width": 1,
            "line-opacity": 0.5,
        },
    });
    map.addLayer({
        id: "track-line",
        type: "line",
        source: "track",
        filter: ["==", "kind", "line"],
        layout: {
            "line-join": "round",
            "line-cap": "round",
        },
        paint: {
            "line-color": selectedColor,
            "line-width": 3,
            "line-opacity": 0.8,
        },
    });
    map.addLayer({
        id: "track-ends",
        type: "circle",
        source: "track",
        filter: ["!=", "kind", "line"],
        paint: {
            "circle-radius": 6,
            "circle-color": ["match", ["get", "kind"], "start", trackStartColor, trackEndColor],
            "circle-stroke-color": "#ffffff",
            "circle-stroke-width": 2,
        },
    });
}

function MapLibre_fitTo(map, markers, locations, track) {
    const matchValue = bounds(markers, locations, track);
    if (matchValue == null) {
    }
    else if ((matchValue[0][0] === matchValue[1][0]) && (matchValue[0][1] === matchValue[1][1])) {
        const maxLatitude_1 = matchValue[1][0];
        const maxLongitude_1 = matchValue[1][1];
        const minLatitude_1 = matchValue[0][0];
        const minLongitude_1 = matchValue[0][1];
        map.jumpTo({
            center: MapLibre_lngLat(minLongitude_1, minLatitude_1),
            zoom: 15,
        });
    }
    else {
        const maxLatitude_2 = matchValue[1][0];
        const maxLongitude_2 = matchValue[1][1];
        const minLatitude_2 = matchValue[0][0];
        const minLongitude_2 = matchValue[0][1];
        map.fitBounds([MapLibre_lngLat(minLongitude_2, minLatitude_2), MapLibre_lngLat(maxLongitude_2, maxLatitude_2)], {
            padding: 48,
            maxZoom: maxFitZoom,
            duration: 0,
        });
    }
}

function MapLibre_View(props) {
    const container = reactApi.useRef(undefined);
    const mapRef = reactApi.useRef(undefined);
    const markersRef = reactApi.useRef(empty_1());
    const patternInput = reactApi.useState(false);
    const isReady = patternInput[0];
    const patternInput_1 = reactApi.useState(5);
    const zoom = patternInput_1[0];
    const track = defaultArg(props.Track, empty_1());
    useEffectDisposableOnce(() => {
        const matchValue = container.current;
        if (matchValue == null) {
        }
        else {
            const map = new Map$({
                container: matchValue,
                style: MapLibre_mapStyle,
                center: MapLibre_lngLat(10.45, 51.16),
                zoom: 5,
                attributionControl: true,
            });
            map.addControl(new NavigationControl({
                showCompass: false,
            }), "top-right");
            const matchValue_1 = bind((container_1) => container_1.current, props.FullscreenContainer);
            if (matchValue_1 == null) {
            }
            else {
                const fullscreenContainer = matchValue_1;
                map.addControl(new FullscreenControl({
                    container: fullscreenContainer,
                }), "top-right");
            }
            map.on("load", (_arg) => {
                MapLibre_addLayers(map);
                patternInput[1](true);
            });
            map.on("zoomend", (_arg_1) => {
                patternInput_1[1](map.getZoom());
            });
            mapRef.current = map;
        }
        const observer_1 = map_10((element_1) => {
            const observer = new ResizeObserver(() => {
                iterate((map_1) => {
                    map_1.resize();
                }, toArray_1(mapRef.current));
            });
            observer.observe(element_1);
            return observer;
        }, container.current);
        return createDisposable(() => {
            iterate((observer_2) => {
                observer_2.disconnect();
            }, toArray_1(observer_1));
            iterate_1((marker) => {
                marker.remove();
            }, markersRef.current);
            markersRef.current = empty_1();
            iterate((map_2) => {
                map_2.remove();
            }, toArray_1(mapRef.current));
            mapRef.current = undefined;
        });
    });
    const dependencies = [isReady, props.Markers, props.LocationMarkers, props.Track, props.Selected, props.SelectedLocation, zoom];
    reactApi.useEffect(() => {
        let map_3;
        const matchValue_2 = mapRef.current;
        let matchResult, map_4;
        if (matchValue_2 != null) {
            if ((map_3 = matchValue_2, isReady)) {
                matchResult = 0;
                map_4 = matchValue_2;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0: {
                iterate_1((marker_1) => {
                    marker_1.remove();
                }, markersRef.current);
                const single = (marker_2) => {
                    const content = clickable(markerElement(marker_2, equals(props.Selected, marker_2.Id)), () => {
                        props.OnSelect(marker_2.Id);
                    });
                    return (new Marker({
                        element: content,
                    })).setLngLat(MapLibre_lngLat(marker_2.Longitude, marker_2.Latitude)).addTo(map_4);
                };
                markersRef.current = ((props.Cluster && (length(props.Markers) >= clusterThreshold)) ? map_9((cluster) => {
                    const matchValue_3 = cluster.Members;
                    let matchResult_1, marker_3;
                    if (!isEmpty(matchValue_3)) {
                        if (isEmpty(tail(matchValue_3))) {
                            matchResult_1 = 0;
                            marker_3 = head(matchValue_3);
                        }
                        else {
                            matchResult_1 = 1;
                        }
                    }
                    else {
                        matchResult_1 = 1;
                    }
                    switch (matchResult_1) {
                        case 0:
                            return single(marker_3);
                        default:
                            return (new Marker({
                                element: clickable(clusterElement(cluster), () => {
                                    map_4.flyTo({
                                        center: MapLibre_lngLat(cluster.Longitude, cluster.Latitude),
                                        zoom: zoom + 2,
                                    });
                                }),
                            })).setLngLat(MapLibre_lngLat(cluster.Longitude, cluster.Latitude)).addTo(map_4);
                    }
                }, clusterMarkers(zoom, props.Markers)) : map_9(single, props.Markers));
                const locationMarkers = map_9((marker_4) => {
                    const content_1 = clickable(locationMarkerElement(marker_4, equals(props.SelectedLocation, marker_4.Id)), () => {
                        props.OnSelectLocation(marker_4.Id);
                    });
                    return (new Marker({
                        element: content_1,
                        anchor: "bottom",
                    })).setLngLat(MapLibre_lngLat(marker_4.Longitude, marker_4.Latitude)).addTo(map_4);
                }, props.LocationMarkers);
                markersRef.current = append(markersRef.current, locationMarkers);
                map_4.getSource("accuracy").setData(MapLibre_accuracyFeatures(props.Markers));
                map_4.getSource("track").setData(MapLibre_trackFeatures(track));
                break;
            }
            case 1: {
                break;
            }
        }
    }, dependencies);
    const dependencies_2 = [isReady, fitKey(props.Markers, props.LocationMarkers, track)];
    reactApi.useEffect(() => {
        let map_5;
        const matchValue_4 = mapRef.current;
        let matchResult_2, map_6;
        if (matchValue_4 != null) {
            if ((map_5 = matchValue_4, isReady)) {
                matchResult_2 = 0;
                map_6 = matchValue_4;
            }
            else {
                matchResult_2 = 1;
            }
        }
        else {
            matchResult_2 = 1;
        }
        switch (matchResult_2) {
            case 0: {
                MapLibre_fitTo(map_6, props.Markers, props.LocationMarkers, track);
                break;
            }
            case 1: {
                break;
            }
        }
    }, dependencies_2);
    const dependencies_4 = [isReady, props.Focus];
    reactApi.useEffect(() => {
        let map_7, longitude, latitude;
        const matchValue_5 = mapRef.current;
        const matchValue_6 = props.Focus;
        let matchResult_3, latitude_1, longitude_1, map_8;
        if (matchValue_5 != null) {
            if (matchValue_6 != null) {
                if ((map_7 = matchValue_5, (longitude = matchValue_6[1], (latitude = matchValue_6[0], isReady)))) {
                    matchResult_3 = 0;
                    latitude_1 = matchValue_6[0];
                    longitude_1 = matchValue_6[1];
                    map_8 = matchValue_5;
                }
                else {
                    matchResult_3 = 1;
                }
            }
            else {
                matchResult_3 = 1;
            }
        }
        else {
            matchResult_3 = 1;
        }
        switch (matchResult_3) {
            case 0: {
                map_8.flyTo({
                    center: MapLibre_lngLat(longitude_1, latitude_1),
                    zoom: 16,
                });
                break;
            }
            case 1: {
                break;
            }
        }
    }, dependencies_4);
    return mapContainer(props.Height, false, container);
}

const Google_defaultMapId = "DEMO_MAP_ID";

function Google_latLng(latitude, longitude) {
    return {
        lat: latitude,
        lng: longitude,
    };
}

function Google_mapOptions(mapId) {
    return {
        center: Google_latLng(51.16, 10.45),
        zoom: 5,
        mapId: mapId,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,
        zoomControl: true,
        clickableIcons: false,
        gestureHandling: "greedy",
    };
}

class Google_Overlays extends Record {
    constructor(Markers, Shapes) {
        super();
        this.Markers = Markers;
        this.Shapes = Shapes;
    }
}

function Google_Overlays_$reflection() {
    return record_type("Widgets.TrackerMap.Google.Overlays", [], Google_Overlays, () => [["Markers", list_type(class_type("Bindings.GoogleMaps.IAdvancedMarker"))], ["Shapes", list_type(class_type("Bindings.GoogleMaps.IOverlay"))]]);
}

const Google_noOverlays = new Google_Overlays(empty_1(), empty_1());

function Google_clearOverlays(overlays) {
    iterate_1((marker) => {
        marker.map = null;
    }, overlays.Markers);
    iterate_1((overlay) => {
        overlay.setMap(null);
    }, overlays.Shapes);
}

function Google_accuracyCircles(map, markers) {
    return choose((marker) => map_10((meters_1) => (new google.maps.Circle({
        map: map,
        center: Google_latLng(marker.Latitude, marker.Longitude),
        radius: meters_1,
        strokeColor: selectedColor,
        strokeOpacity: 0.5,
        strokeWeight: 1,
        fillColor: selectedColor,
        fillOpacity: 0.12,
        clickable: false,
    })), filter((meters) => (meters >= accuracyCircleFrom), marker.AccuracyMeters)), markers);
}

function Google_centered(content) {
    content.style.transform = "translateY(50%)";
    return content;
}

function Google_dotElement(color, testId) {
    const element = document.createElement("div");
    element.setAttribute("data-test-id", testId);
    element.setAttribute("style", concat("width: 12px; height: 12px; border-radius: 50%; background: ", color, ..."; border: 2px solid #ffffff; box-shadow: 0 1px 4px rgba(0,0,0,0.4);"));
    return Google_centered(element);
}

function Google_trackOverlays(map, track) {
    if (isEmpty(track)) {
        return Google_noOverlays;
    }
    else {
        const points = track;
        const path = toArray(map_9((point) => Google_latLng(point.Latitude, point.Longitude), points));
        const line = new google.maps.Polyline({
            map: map,
            path: path,
            strokeColor: selectedColor,
            strokeWeight: 3,
            strokeOpacity: 0.8,
            clickable: false,
        });
        const endpoint = (point_1, color, testId) => (new google.maps.marker.AdvancedMarkerElement({
            map: map,
            position: Google_latLng(point_1.Latitude, point_1.Longitude),
            content: Google_dotElement(color, testId),
        }));
        return new Google_Overlays(ofArray([endpoint(head(points), trackStartColor, "tracker-track-start"), endpoint(last_1(points), trackEndColor, "tracker-track-end")]), singleton_1(line));
    }
}

function Google_clickableMarker(map, latitude, longitude, content, onClick) {
    return new google.maps.marker.AdvancedMarkerElement({
        map: map,
        position: Google_latLng(latitude, longitude),
        content: Google_centered(clickable(content, onClick)),
        gmpClickable: true,
    });
}

function Google_clickablePinMarker(map, latitude, longitude, content, onClick) {
    return new google.maps.marker.AdvancedMarkerElement({
        map: map,
        position: Google_latLng(latitude, longitude),
        content: clickable(content, onClick),
        gmpClickable: true,
    });
}

function Google_fullscreenControl(container, title) {
    const button = document.createElement("button");
    button.setAttribute("type", "button");
    button.setAttribute("data-test-id", "tracker-map-fullscreen");
    button.title = title;
    button.setAttribute("style", "margin: 10px; width: 40px; height: 40px; background: #ffffff; border: 0; border-radius: 2px; box-shadow: 0 1px 4px rgba(0,0,0,0.3); cursor: pointer; display: flex; align-items: center; justify-content: center;");
    button.innerHTML = "<svg width=\"18\" height=\"18\" viewBox=\"0 0 18 18\" fill=\"none\" stroke=\"#666666\" stroke-width=\"2\" stroke-linecap=\"round\"><path d=\"M2 7V2h5M11 2h5v5M16 11v5h-5M7 16H2v-5\"/></svg>";
    button.onclick = ((_arg) => {
        if (Operators_IsNull(document.fullscreenElement)) {
            container.requestFullscreen();
        }
        else {
            document.exitFullscreen();
        }
    });
    return button;
}

function Google_fitTo(map, markers, locations, track) {
    const matchValue = bounds(markers, locations, track);
    if (matchValue == null) {
    }
    else if ((matchValue[0][0] === matchValue[1][0]) && (matchValue[0][1] === matchValue[1][1])) {
        const maxLatitude_1 = matchValue[1][0];
        const maxLongitude_1 = matchValue[1][1];
        const minLatitude_1 = matchValue[0][0];
        const minLongitude_1 = matchValue[0][1];
        map.setCenter(Google_latLng(minLatitude_1, minLongitude_1));
        map.setZoom(15);
    }
    else {
        const maxLatitude_2 = matchValue[1][0];
        const maxLongitude_2 = matchValue[1][1];
        const minLatitude_2 = matchValue[0][0];
        const minLongitude_2 = matchValue[0][1];
        map.fitBounds(new google.maps.LatLngBounds(Google_latLng(minLatitude_2, minLongitude_2), Google_latLng(maxLatitude_2, maxLongitude_2)), 48);
        google.maps.event.addListenerOnce(map, "idle", (() => {
            if (map.getZoom() > maxFitZoom) {
                map.setZoom(maxFitZoom);
            }
        }));
    }
}

function Google_View(props) {
    const t = useTranslation()[0];
    const configuration = useMapConfiguration();
    const container = reactApi.useRef(undefined);
    const mapRef = reactApi.useRef(undefined);
    const overlaysRef = reactApi.useRef(Google_noOverlays);
    const generation = reactApi.useRef(0);
    const patternInput_1 = reactApi.useState(false);
    const setIsReady = patternInput_1[1];
    const isReady = patternInput_1[0];
    const patternInput_2 = reactApi.useState(false);
    const setLoadFailed = patternInput_2[1];
    const loadFailed = patternInput_2[0];
    const patternInput_3 = reactApi.useState(5);
    const zoom = patternInput_3[0];
    const track = defaultArg(props.Track, empty_1());
    const apiKey = bind((configuration_1) => configuration_1.GoogleMapsApiKey, configuration.data);
    const mapId = defaultArg(bind((configuration_2) => configuration_2.GoogleMapsMapId, configuration.data), Google_defaultMapId);
    useEffectWithDeps(() => {
        generation.current = (generation.current + 1);
        const current = generation.current | 0;
        const isCurrent = () => (generation.current === current);
        setLoadFailed(false);
        const matchValue = container.current;
        let matchResult, apiKey_1, element;
        if (matchValue != null) {
            if (apiKey != null) {
                matchResult = 0;
                apiKey_1 = apiKey;
                element = matchValue;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0: {
                window.gm_authFailure = (() => {
                    if (isCurrent()) {
                        setLoadFailed(true);
                    }
                });
                let pr_2;
                let pr_1;
                const pr = load(apiKey_1);
                pr_1 = (pr.then(() => {
                    if (isCurrent()) {
                        const map = new google.maps.Map(element, Google_mapOptions(mapId));
                        iterate((fullscreenContainer_1) => {
                            map.controls[google.maps.ControlPosition.TOP_RIGHT].push(Google_fullscreenControl(fullscreenContainer_1, t("telematics.map.fullscreen")));
                        }, toArray_1(bind((fullscreenContainer) => fullscreenContainer.current, props.FullscreenContainer)));
                        map.addListener("idle", (_arg) => {
                            patternInput_3[1](map.getZoom());
                        });
                        mapRef.current = map;
                        setIsReady(true);
                    }
                }));
                pr_2 = (pr_1.then(void 0, ((_arg_1) => {
                    if (isCurrent()) {
                        setLoadFailed(true);
                    }
                })));
                pr_2.then();
                break;
            }
        }
        return createDisposable(() => {
            generation.current = (generation.current + 1);
            delete window.gm_authFailure;
            Google_clearOverlays(overlaysRef.current);
            overlaysRef.current = Google_noOverlays;
            iterate((map_1) => {
                google.maps.event.clearInstanceListeners(map_1);
            }, toArray_1(mapRef.current));
            mapRef.current = undefined;
            setIsReady(false);
        });
    }, [apiKey, mapId]);
    const dependencies_1 = [isReady, props.Markers, props.LocationMarkers, props.Track, props.Selected, props.SelectedLocation, zoom];
    reactApi.useEffect(() => {
        let map_2;
        const matchValue_2 = mapRef.current;
        let matchResult_1, map_3;
        if (matchValue_2 != null) {
            if ((map_2 = matchValue_2, isReady)) {
                matchResult_1 = 0;
                map_3 = matchValue_2;
            }
            else {
                matchResult_1 = 1;
            }
        }
        else {
            matchResult_1 = 1;
        }
        switch (matchResult_1) {
            case 0: {
                Google_clearOverlays(overlaysRef.current);
                const single = (marker) => Google_clickableMarker(map_3, marker.Latitude, marker.Longitude, markerElement(marker, equals(props.Selected, marker.Id)), () => {
                    props.OnSelect(marker.Id);
                });
                const trackerMarkers = (props.Cluster && (length(props.Markers) >= clusterThreshold)) ? map_9((cluster) => {
                    const matchValue_3 = cluster.Members;
                    let matchResult_2, marker_1;
                    if (!isEmpty(matchValue_3)) {
                        if (isEmpty(tail(matchValue_3))) {
                            matchResult_2 = 0;
                            marker_1 = head(matchValue_3);
                        }
                        else {
                            matchResult_2 = 1;
                        }
                    }
                    else {
                        matchResult_2 = 1;
                    }
                    switch (matchResult_2) {
                        case 0:
                            return single(marker_1);
                        default:
                            return Google_clickableMarker(map_3, cluster.Latitude, cluster.Longitude, clusterElement(cluster), () => {
                                map_3.setCenter(Google_latLng(cluster.Latitude, cluster.Longitude));
                                map_3.setZoom(zoom + 2);
                            });
                    }
                }, clusterMarkers(zoom, props.Markers)) : map_9(single, props.Markers);
                const locationMarkers = map_9((marker_2) => Google_clickablePinMarker(map_3, marker_2.Latitude, marker_2.Longitude, locationMarkerElement(marker_2, equals(props.SelectedLocation, marker_2.Id)), () => {
                    props.OnSelectLocation(marker_2.Id);
                }), props.LocationMarkers);
                const trackOverlays = Google_trackOverlays(map_3, track);
                overlaysRef.current = (new Google_Overlays(append(trackerMarkers, append(locationMarkers, trackOverlays.Markers)), append(Google_accuracyCircles(map_3, props.Markers), trackOverlays.Shapes)));
                break;
            }
            case 1: {
                break;
            }
        }
    }, dependencies_1);
    const dependencies_3 = [isReady, fitKey(props.Markers, props.LocationMarkers, track)];
    reactApi.useEffect(() => {
        let map_4;
        const matchValue_4 = mapRef.current;
        let matchResult_3, map_5;
        if (matchValue_4 != null) {
            if ((map_4 = matchValue_4, isReady)) {
                matchResult_3 = 0;
                map_5 = matchValue_4;
            }
            else {
                matchResult_3 = 1;
            }
        }
        else {
            matchResult_3 = 1;
        }
        switch (matchResult_3) {
            case 0: {
                Google_fitTo(map_5, props.Markers, props.LocationMarkers, track);
                break;
            }
            case 1: {
                break;
            }
        }
    }, dependencies_3);
    const dependencies_5 = [isReady, props.Focus];
    reactApi.useEffect(() => {
        let map_6, longitude, latitude;
        const matchValue_5 = mapRef.current;
        const matchValue_6 = props.Focus;
        let matchResult_4, latitude_1, longitude_1, map_7;
        if (matchValue_5 != null) {
            if (matchValue_6 != null) {
                if ((map_6 = matchValue_5, (longitude = matchValue_6[1], (latitude = matchValue_6[0], isReady)))) {
                    matchResult_4 = 0;
                    latitude_1 = matchValue_6[0];
                    longitude_1 = matchValue_6[1];
                    map_7 = matchValue_5;
                }
                else {
                    matchResult_4 = 1;
                }
            }
            else {
                matchResult_4 = 1;
            }
        }
        else {
            matchResult_4 = 1;
        }
        switch (matchResult_4) {
            case 0: {
                map_7.panTo(Google_latLng(latitude_1, longitude_1));
                map_7.setZoom(16);
                break;
            }
            case 1: {
                break;
            }
        }
    }, dependencies_5);
    const hint = (testId, text) => reactElement("div", {
        "data-test-id": testId,
        className: join(" ", ["text-sm", "text-gray-600"]),
        children: text,
    });
    if (configuration.data != null) {
        if (apiKey != null) {
            const xs_1 = toList(delay(() => append_1(loadFailed ? singleton(hint("tracker-map-unavailable", t("telematics.map.unavailable"))) : empty(), delay(() => singleton(mapContainer(props.Height, loadFailed, container))))));
            return react.createElement(react.Fragment, {}, ...xs_1);
        }
        else {
            return hint("tracker-map-not-configured", t("telematics.map.not_configured"));
        }
    }
    else if (configuration.error != null) {
        return hint("tracker-map-unavailable", t("telematics.map.unavailable"));
    }
    else {
        return createElement(Skeleton, {
            Variant: "normal",
        });
    }
}

export function MapLibreTrackerMap(props) {
    return createElement(MapLibre_View, props);
}

export function GoogleTrackerMap(props) {
    return createElement(Google_View, props);
}

export function TrackerMap(props) {
    return GoogleTrackerMap(props);
}

